import React from 'react';
import { useTranslations } from '../hooks/useTranslations';
export function HowItWorks() {
  const {
    t
  } = useTranslations();
  return <section id="how-it-works" className="py-12 bg-white" data-id="element-179">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-180">
        <div className="text-center mb-10" data-id="element-181">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-182">
            {t('howItWorks.title')}
          </h2>
        </div>

        {/* Detail Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10" data-id="element-183">
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 text-center" data-id="element-184">
            <div className="px-3 py-1 rounded-md bg-blue-500 text-white flex items-center justify-center text-[11px] font-bold mb-3 mx-auto w-fit" data-id="element-185">
              PASO 1
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-1 uppercase" data-id="element-186">
              {t('howItWorks.step1.title')}
            </h3>
            <p className="text-xs text-gray-500 leading-relaxed" data-id="element-187">
              {t('howItWorks.step1.desc')}
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 text-center" data-id="element-188">
            <div className="px-3 py-1 rounded-md bg-orange-500 text-white flex items-center justify-center text-[11px] font-bold mb-3 mx-auto w-fit" data-id="element-189">
              PASO 2
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-1 uppercase" data-id="element-190">
              {t('howItWorks.step2.title')}
            </h3>
            <p className="text-xs text-gray-500 leading-relaxed" data-id="element-191">
              {t('howItWorks.step2.desc')}
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 text-center" data-id="element-192">
            <div className="px-3 py-1 rounded-md bg-emerald-500 text-white flex items-center justify-center text-[11px] font-bold mb-3 mx-auto w-fit" data-id="element-193">
              PASO 3
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-1 uppercase" data-id="element-194">
              {t('howItWorks.step3.title')}
            </h3>
            <p className="text-xs text-gray-500 leading-relaxed" data-id="element-195">
              {t('howItWorks.step3.desc')}
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-196">
          <a href="https://form.jotform.com/260402880146048" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center text-sm font-bold px-8 py-3.5 rounded-lg text-white bg-[#00E676] hover:bg-[#00d169] shadow-lg shadow-green-200/50 hover:shadow-xl hover:shadow-green-300/50 hover:scale-[1.03] active:scale-[0.98] transition-all duration-300" data-id="element-197">
            {t('howItWorks.cta')}
          </a>
        </div>
      </div>
    </section>;
}